import { financeAPI } from "../../axios";

export const actions = {
    createActualCashTransactions(context, data) {
        return financeAPI.post(`ActualCashTransaction/CreateActualCashTransaction`, data);
    },
    getActualCashTransactions(context, { fundSourceId, cycle }) {
        return financeAPI.get(`ActualCashTransaction/FundSource/${fundSourceId}/${cycle}`);
    }
}

